import React from 'react';
import { useLocation } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import AppDrawer from './components/AppDrawer';
import AppTopBar from './components/AppTopBar';
import { Typography, Container, Box } from '@mui/material';

import { useAuth } from './context/AuthContext';

function App() {
    const { isAuthenticated } = useAuth();
    const location = useLocation();
    const isPrintRoute = location.pathname.includes('/print');

    if (isAuthenticated && isPrintRoute) {
        return (
            <Box className="rx-print-root" sx={{ minHeight: '100vh', backgroundColor: '#fff', p: 3 }}>
                <AppRoutes />
            </Box>
        );
    }

    return (
        <>
            {isAuthenticated ? (
                <Box
                    className="app-chrome"
                    sx={{
                        pt: { xs: '56px', sm: '64px' },
                        pb: '36px',
                        boxSizing: 'border-box',
                        minHeight: '100vh',
                        position: 'relative',
                    }}
                >
                    <AppTopBar />
                    <Box sx={{ display: 'flex' }}>
                        <AppDrawer />
                        <Box
                            component="main"
                            sx={{
                                flexGrow: 1,
                                minWidth: '0',
                                p: '20px',
                                minHeight: '100%',
                                backgroundColor: '#f5f5f5',
                            }}
                        >
                            <AppRoutes />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: '0',
                            left: '0',
                            right: '0',
                            pl: { lg: '240px' },
                            textAlign: 'center',
                            height: '36px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <Container maxWidth="xl">
                            <Box sx={{ position: 'relative' }}>
                                <Typography
                                    variant="body2"
                                    sx={{ color: 'text.secondary' }}
                                >
                                    &copy; 2024 Doctor Mohsin Kidney Clinic
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        display: {
                                            xs: 'none',
                                            sm: 'block',
                                        },
                                        position: { sm: 'absolute' },
                                        right: '0',
                                        top: '50%',
                                        transform: {
                                            sm: 'translateY(-50%)',
                                        },
                                        color: 'rgba(0,0,0,0.28)',
                                    }}
                                >
                                    Design &amp; developed by Qaiser
                                </Typography>
                            </Box>
                        </Container>
                    </Box>
                </Box>
            ) : (
                <AppRoutes />
            )}
        </>
    );
}

export default App;
